import { ENDPOINTS } from "../endpoints";
import { formatLogFilterDate } from "../../utils/logUtils";

const parseError = async (response) => {
    const error = await response.json().catch(() => ({}));
    throw new Error(
        error.message || `HTTP error! Status: ${response.status}`,
    );
};

/** GET /api/acp/get-logs */
export const getLogs = async ({
    logType,
    page = 1,
    pageLimit = 20,
    accountName,
    characterName,
    dateFrom,
    dateTo,
}) => {
    const url = new URL(ENDPOINTS.ACP.GET_LOGS);
    url.searchParams.set("logType", String(logType));
    url.searchParams.set("page", String(page));
    url.searchParams.set("pageLimit", String(pageLimit));

    if (accountName?.trim()) {
        url.searchParams.set("accountName", accountName.trim());
    }
    if (characterName?.trim()) {
        url.searchParams.set("characterName", characterName.trim());
    }
    if (dateFrom) {
        url.searchParams.set("dateFrom", formatLogFilterDate(dateFrom, false));
    }
    if (dateTo) {
        url.searchParams.set("dateTo", formatLogFilterDate(dateTo, true));
    }

    const headers = { Accept: "application/json" };
    const token = localStorage.getItem("jwtToken");
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(url.toString(), {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        await parseError(response);
    }

    const data = await response.json();

    return {
        items: data.data ?? [],
        currentPage: Number(data.currentPage ?? page),
        totalPages: Number(data.totalPages ?? 1),
        totalItems: Number(data.totalItems ?? 0),
    };
};
